import React from "react";

import TableWrapper from "../tableWrapper/tableWrapper.component";

import { StyledWrapper } from "./tableLayout.style";

const TableLayout = ({ heading, name }) => {
  return (
    <StyledWrapper>
      <div className="page-heading">
        <h1>{heading || "\u00A0"}</h1>
      </div>
      <TableWrapper name={name} />
    </StyledWrapper>
  );
};

export default TableLayout;
